import { render, staticRenderFns } from "./selBank.vue?vue&type=template&id=3569995d&scoped=true&"
import script from "./selBank.vue?vue&type=script&lang=ts&"
export * from "./selBank.vue?vue&type=script&lang=ts&"
import style0 from "./selBank.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./selBank.vue?vue&type=style&index=1&id=3569995d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569995d",
  null
  
)

export default component.exports